import Filter from '@/src/components/organism/Filter';
import { useEffect, useRef, useState } from 'react';
import { faqFilters } from './filter';
import { useQuery } from '@tanstack/react-query';
import useQueryValues from '@/src/hooks/useQueryValues';
import MainContentTitle from '@/src/components/molecule/MainContentTitle';
import { AgGridReact } from 'ag-grid-react';
import Table from '@/src/components/atom/Table';
import { faqListColumn } from './column';
import SectionCardNoneTitle from '@/src/components/molecule/SectionCardNoneTitle';
import Typo from '@/src/components/atom/Typo';
import Button from '@/src/components/atom/Button';
import LucideIcon from '@/src/components/atom/Icons/LucideIcon';
import usePaginationQuery from '@/src/hooks/usePaginationQuery';
import { NAV_CONST } from '@/src/constants/nav';
import { getFaqCategoriesAPI, getFaqsAPI } from '@/src/apis/rest/faq';
import { Link, useNavigate } from 'react-router-dom';
import PATH from '@/src/routes/path';

export default function FaqListPage() {
  const navigate = useNavigate();

  const { defaultValues } = useQueryValues({
    createdAt: ['createdAtFrom', 'createdAtTo'],
  });
  const { page, pageSize, handlePageChange } = usePaginationQuery();

  const gridRef = useRef<AgGridReact>(null);
  const [values, setValues] = useState(defaultValues);

  const { data: faqCategories } = useQuery({
    queryKey: ['faq-category'],
    queryFn: getFaqCategoriesAPI,
  });

  const {
    data: FaqListOrigin,
    isError,
    isFetching,
  } = useQuery({
    queryKey: ['Faqs', values, page, pageSize],
    queryFn: () => {
      return getFaqsAPI({
        ...values,
        page,
        pageSize,
      });
    },
  });

  useEffect(() => {
    if (isFetching && gridRef.current) {
      gridRef.current.api?.showLoadingOverlay();
    }
  }, [isFetching]);

  return (
    <>
      <MainContentTitle
        pageTitle={NAV_CONST.faqManagement}
        breadcrumbList={[NAV_CONST.faq]}
      />
      <div className="mb-20 flex flex-col gap-6">
        <Filter
          title="검색 필터"
          filters={faqFilters(
            (faqCategories || []).map(item => ({ label: item, value: item })),
          )}
          onSubmit={values => {
            handlePageChange(1, pageSize, false);
            setValues(values);
          }}
        />
        <div className="flex flex-col gap-y-6">
          <SectionCardNoneTitle
            contentProps={{
              className: 'flex flex-col gap-y-4',
            }}
          >
            <div className="flex items-center justify-between">
              <Typo typoType="b18m">FAQ 목록</Typo>
              <Link to={PATH.FAQ_CREAET}>
                <Button buttonSize="medium" onClick={() => {}}>
                  <div className="flex items-center gap-x-2">
                    <LucideIcon name="Plus" color="white" />
                    FAQ 등록
                  </div>
                </Button>
              </Link>
            </div>

            <Table
              ref={gridRef}
              rowData={isError ? [] : FaqListOrigin?.rows || []}
              isPaginationDataMapping
              columnDefs={faqListColumn(e => {
                navigate(PATH.FAQ_DETAIL.replace(':id', String(e)));
              })}
              total={FaqListOrigin?.count || 0}
              page={page}
              pageSize={pageSize}
              handlePaginationClick={handlePageChange}
            />
          </SectionCardNoneTitle>
        </div>
      </div>
    </>
  );
}
